/* eslint-disable */
export const VERSION = process.env.NPM_PACKAGE_VERSION
export const SENTRY_RELEASE = process.env.SENTRY_RELEASE
